export interface ConfirmationConfig<TPreview = unknown> {
  phone: string;
  lawyerInfo: TPreview | null;
  title: string;
  label: string;
  submitText: string;
  onSubmit: (code: string) => Promise<string>;
  onResend: () => Promise<void>;
}

const config: Ref<ConfirmationConfig | null> = ref(null);

export const useConfirmation = () => {
  const setConfig = (value: ConfirmationConfig | null): void => {
    config.value = value;
  };

  return { config, setConfig };
};

export default useConfirmation;
